module.exports = __webpack_public_path__ + "img/jigou3.90e57801.png";